module.exports = "<react-document-list-table></react-document-list-table> ";